var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236 118C236 183.185 183.2 236 118 236C52.8 236 0 183.185 0 118C0 52.8153 52.8 0 118 0C183.2 0 236 52.8153 236 118ZM70.7 119.178C60.8 110.637 49.8 121.632 56.3 128.013C66.2 137.634 89.3 159.231 89.3 159.231C89.3 159.231 100.7 171.797 109.9 160.802C121.7 146.764 168.6 92.6722 173.3 87.4692C177.9 82.4626 168 67.8353 157.7 77.9468C144.7 90.7088 113.9 129.093 108.9 134.493C103.8 139.794 99.7 146.862 93.3 140.383C86 132.725 70.7 119.178 70.7 119.178Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitSi);
export default __webpack_public_path__ + "static/media/visitSi.22129811c661aa724445e28533c59eb1.svg";
export { ForwardRef as ReactComponent };